import Menubar from './Menubar.vue'

/*
export default {
  install (Vue) {
    Vue.component('menubar', Menubar)
  }
}

export { Menubar }
*/

export default Menubar;
